import { ReactNode } from 'react'
import bannerDesktop from '../assets/auth/banner-desktop.png'
import bannerMobile from '../assets/auth/banner-mobile.png'

type Props = {
  children: ReactNode
}

export default function AuthLayout({ children }: Props) {
  return (
    <div className="flex min-h-screen flex-col bg-ce-off-white font-sans">
      <img
        src={bannerMobile}
        alt=""
        aria-hidden="true"
        className="h-[266px] w-full object-cover object-center md:hidden"
      />
      <img
        src={bannerDesktop}
        alt=""
        aria-hidden="true"
        className="hidden h-[266px] w-full object-cover object-center md:block"
      />

      <main className="flex flex-1 flex-col items-center px-0 md:px-4 md:pt-[50px]">
        <div className="w-full max-w-[600px] bg-white px-5 py-10 shadow-[0_10px_20px_0_rgba(189,205,199,0.5)] md:rounded-xl md:px-20">
          {children}
        </div>
      </main>

      <footer className="border-t border-gray-200 py-8 text-center">
        <p className="font-display text-xs font-medium text-gray-500 md:text-base">
          © 2026 Exhibition Intelligence MVP. All rights reserved. Powered by{' '}
          <a
            href="https://cloudexpo.my"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-700"
          >
            CloudExpo
          </a>
          .
        </p>
      </footer>
    </div>
  )
}
